import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

const TextInput = (props) => {
  const {
    name,
    label,
    disabled = false,
    type = "text",
    className = "",
    placeholder = "",
    helperText = "",
  } = props;

  const {
    register,
    formState: { errors },
  } = useFormContext();
  // const errors = formState.errors;

  return (
    <div>
      {label ? <Form.Label className="m-0 " style={{fontSize:"12px"}} htmlFor={name}>{label}</Form.Label> : null}
      <Form.Control
        size="sm"
        type={type}
        disabled={disabled}
        id={name}
        name={name}
        placeholder={placeholder}
        {...register(name)}
        className={"form-control " + (errors[name] ? " border border-danger " : "") + className}
        onWheel={(e) => {
          if (type === "number") return e.target.blur();
          return;
        }}
      />
      {/* {errors[name] && (
        <small className="fw-semibold text-danger mb-0 mt-2 d-block">{errors[name]?.message}</small>
      )} */}
      {errors[name] && (
        <small className="fw-semibold text-danger mb-0  d-block">{errors[name]?.message}</small>
      )}
      {helperText && (
        <small
          // className={"fw-semibold mt-1 mb-0 d-block " + (errors[name] ? " text-danger " : "")}
          className={"fw-semibold  mb-0 d-block " + (errors[name] ? " text-danger " : "")}
          style={{ color: "#3B3B3B" }}
        >
          {helperText}
        </small>
      )}
    </div>
  );
};

export default TextInput;
